import {
  DynamicallyFilteredLeadsDocument,
  DynamicallyFilteredLeadsQuery,
  DynamicallyFilteredLeadsQueryVariables,
  useDynamicallyFilteredLeadsQuery,
} from 'graphql/bindings/AdminBindings'
import { LeadFilters } from './LeadsDashboardFilter'
import { QueryResult } from 'react-apollo'
import moment from 'moment'

const serverFilters: { [key: string]: string } = {
  netWorth: 'net_worth',
  targetCheckSize: 'target_check_size',
  emailVerified: 'email_verified',
  leadStatus: 'lead_status',
  isAccredited: 'is_accredited',
  dateSignedUp: 'created_at',
  profileAssignee: 'profiling_assignee',
}

interface DynamicQueryFilter {
  name: string
  operation: '=' | 'in' | '>='
  value: any
}

// These filters are NOT controllable by the end user
const queryFilters: DynamicQueryFilter[] = [
  { name: 'is_investor', operation: '=', value: true },
  { name: 'type', operation: 'in', value: ['individual'] },
  { name: 'do_not_contact_reasons', operation: 'in', value: [undefined, 'is_unsubscribed_from_deal_related_emails'] },
  { name: 'owners', operation: 'in', value: [null] },
]

type LeadsDataSourceMeta = {
  variables: DynamicallyFilteredLeadsQueryVariables
  query: any
}

export const useLeadsDataSource = (
  offset: number,
  limit: number,
  filters: LeadFilters
): [QueryResult<DynamicallyFilteredLeadsQuery>, LeadsDataSourceMeta] => {
  const variables = {
    filter: JSON.stringify({
      filters: Object.entries(filters)
        .filter(([_, value]) => value !== undefined)
        .map(([key, value]) => {
          if (['netWorth', 'targetCheckSize'].includes(key)) {
            return {
              name: serverFilters[key],
              operation: 'in',
              value,
            }
          } else if (key === 'dateSignedUp') {
            return {
              name: serverFilters[key],
              operation: '>=',
              value: moment(value as Date)
                .startOf('day')
                .toISOString(),
            }
          }
          return {
            name: serverFilters[key] || key,
            operation: '=',
            value,
          }
        })
        .concat(queryFilters),
      logicOp: 'and',
    }),
    offset: offset,
    limit: limit,
  }

  return [
    useDynamicallyFilteredLeadsQuery({ variables, fetchPolicy: 'network-only' }),
    { variables, query: DynamicallyFilteredLeadsDocument },
  ]
}
